/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Payment_AllInputs */

const vi_order_payment_all = /** @type {(inputs: Order_Payment_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả thanh toán`)
};

/**

* @param {Order_Payment_AllInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_payment_all = /** @type {((inputs?: Order_Payment_AllInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Payment_AllInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_payment_all(inputs)
});